$(document).ready(function () {
  // 子要素を初期状態で非表示にします
  $('.p-hamburger__navListChilds').hide();

  // has-childクラスを持つ要素をクリックしたときの処理
  $('.p-hamburger__navList.has-child').click(function (event) {
    event.preventDefault();
    // クリックされた要素の子要素をスライドトグルで表示/非表示にします
    $(this).children('.p-hamburger__navListChilds').slideToggle();

    // アイコンのアニメーションを実装するために、openクラスを切り替えます
    $(this).find('.icon-toggle').toggleClass('open');
  });
});

$(document).ready(function () {
  var lastWidth = $(window).width();

  function toggleAccordion() {
    if ($(window).width() <= 1024) {
      $('.l-footer__linksChilds').hide();
      $('.l-footer__linksWrap.has-child').off().on('click', function (event) {
        event.preventDefault();
        $(this).children('.l-footer__linksChilds').slideToggle();

        // アイコンのアニメーションを実装するために、openクラスを切り替えます
        $(this).find('.icon-toggle').toggleClass('open');
      });

      // 子要素のaタグクリックイベントでイベント伝播を停止する
      $('.l-footer__linksChilds a').click(function (event) {
        event.stopPropagation();
      });

    } else {
      $('.l-footer__linksChilds').show();
      $('.has-child').off();
    }
  }

  function handleResize() {
    var currentWidth = $(window).width();

    // Check if the width has changed and ignore height changes
    if (lastWidth !== currentWidth) {
      toggleAccordion();
      lastWidth = currentWidth;
    }
  }

  toggleAccordion();
  $(window).on('resize', handleResize);
});



$(function () {
  // 最初に.p-faq__answer要素を隠す
  $('.p-faq__answer').hide();

  // .p-faq__questionをクリックしたときに.p-faq__answer要素をスライドで開閉する
  $('.p-faq__question').on('click', function () {
    $(this).siblings('.p-faq__answer').slideToggle(300);
    $(this).find('.p-faq__toggle').toggleClass('open');
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const elements = document.getElementsByClassName("p-faq__question");

  for (let i = 0; i < elements.length; i++) {
    elements[i].addEventListener("click", function () {
      if (elements[i].classList.contains("no-hover")) {
        elements[i].classList.remove("no-hover");
      } else {
        elements[i].classList.add("no-hover");
      }
    });
  }
});